import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SEOProps } from './SEO.types';
import { SEO_CONSTANTS } from '../../constants/seo.constants';

export const SEO = ({
  title,
  description,
  keywords,
  ogImage = SEO_CONSTANTS.DEFAULT_OG_IMAGE,
  canonicalUrl,
  type = 'website',
}: SEOProps) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const alternateLang = currentLang === 'en' ? 'es' : 'en';

  const fullCanonicalUrl = `${SEO_CONSTANTS.BASE_URL}${canonicalUrl}`;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${SEO_CONSTANTS.BASE_URL}${ogImage}`;

  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <link rel="canonical" href={fullCanonicalUrl} />
      <link rel="alternate" hrefLang={currentLang} href={fullCanonicalUrl} />
      <link rel="alternate" hrefLang={alternateLang} href={fullCanonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={fullCanonicalUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:site_name" content={SEO_CONSTANTS.SITE_NAME} />
      <meta property="og:locale" content={currentLang === 'en' ? 'en_US' : 'es_ES'} />
      <meta property="og:locale:alternate" content={currentLang === 'en' ? 'es_ES' : 'en_US'} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={SEO_CONSTANTS.TWITTER_HANDLE} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
    </Helmet>
  );
};
